import { render, staticRenderFns } from "./addMappingDomain.vue?vue&type=template&id=08ca4400"
import script from "./addMappingDomain.vue?vue&type=script&lang=js"
export * from "./addMappingDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports